var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNumber10SvgrepoCom = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "#ECECEC",
  viewBox: "-3.2 -3.2 38.40 38.40",
  stroke: "#ECECEC",
  strokeWidth: 0.00032,
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "SVGRepo_bgCarrier",
  strokeWidth: 0,
  transform: "translate(3.1999999999999993,3.1999999999999993), scale(0.8)"
}, /*#__PURE__*/React.createElement("rect", {
  x: -3.2,
  y: -3.2,
  width: 38.4,
  height: 38.4,
  rx: 19.2,
  fill: "#7F7F7F",
  strokeWidth: 0
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  id: "SVGRepo_tracerCarrier",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: "#CCCCCC",
  strokeWidth: 0.064
})), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  id: "SVGRepo_iconCarrier"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 3c-7.18 0-13 5.82-13 13s5.82 13 13 13 13-5.82 13-13-5.82-13-13-13zM17.757 22.536h-2.469v-9.305c-0.901 0.841-1.964 1.463-3.188 1.867v-2.234c0.644-0.211 1.344-0.612 2.099-1.202s1.273-1.278 1.555-2.064h2.003v12.938z"
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNumber10SvgrepoCom, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/number10-svgrepo-com.296f7ff1.svg";
export { ForwardRef as ReactComponent };